import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsService } from '@markpieszak/ng-application-insights';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private appInsightsService: AppInsightsService) {}

  handleError(error: any) {
    // Print the error to the console.
    console.error(error);
    this.appInsightsService.trackException(error);
  }
}
